/* eslint-disable no-console */
export class Logger {
    static log(title: string, msg?: unknown, type?: 'info' | 'error' | 'warn') {
        console[type || 'info'](title, msg);
    }
    static error(msg: unknown, error?: Error) {
        console.error(msg, error);
    }
    static warn(...args: unknown[]) {
        console.warn(...args);
    }
    static info(...args: unknown[]) {
        console.info(...args);
    }
}
